export default __webpack_public_path__ + "static/media/f5.d9b7ce35.svg";